import {TEAL_550} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const PathSegment = styled.span`
  cursor: pointer;
  &:hover {
    color: ${TEAL_550};
  }
`;
PathSegment.displayName = 'S.PathSegment';
